var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGavel = function SvgGavel(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 99,
    height: 75,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#10A2FC",
    clipPath: "url(#clip0_4035_24351)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M94.58 75H52.2v-9.34h42.38V75Zm-39.92-2.46h37.47v-4.42H54.66v4.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.03 72.54H48.76V75h49.27v-2.46Zm-36.8-25.98L45.7 19.69 66.86 7.47l15.5 26.87-21.13 12.22ZM49.06 20.58 62.1 43.19 79 33.43 65.95 10.82l-16.9 9.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m44.31 23.35-4.67-8.08L66.07 0l4.67 8.09L44.3 23.33v.02Zm-1.3-7.18 2.21 3.84L67.4 7.21l-2.22-3.84-22.17 12.78v.03Zm19.03 37.89-4.67-8.1L83.79 30.7l4.67 8.1-26.42 15.26Zm-1.3-7.18 2.2 3.83 22.18-12.8-2.21-3.84-22.18 12.8Zm-11.88-4.75-5.48-9.48 9.49-5.49 5.48 9.5-9.49 5.47Zm-2.11-8.58 3.02 5.24 5.24-3.02-3.03-5.24-5.23 3.02ZM6.46 65.93a4.27 4.27 0 0 1-3.7-2.14l-1.2-2.11a4.27 4.27 0 0 1 1.58-5.83L39.99 34.6l5.48 9.49L8.6 65.36c-.67.37-1.38.57-2.12.57h-.02Zm32.6-27.98L4.33 58.01a1.8 1.8 0 0 0-.83 1.11c-.13.47-.05.96.17 1.38l1.2 2.11a1.84 1.84 0 0 0 2.49.66l34.7-20.03-3-5.24v-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.56 35.7 41 38.92l1.23 2.13 5.56-3.2-1.23-2.13ZM8.13 54.4 6 55.65 10.25 63l2.13-1.23-4.25-7.36Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4035_24351"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.98 0h97.05v75H.98z"
  })))));
};
export default SvgGavel;